import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import p1HomeView from "../views/p1HomeView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/c/",
    name: "p1HomeView",
    component: p1HomeView,
  },
  {
    path: "/c/:conversation_uid/verify",
    name: "p1HomeView",
    component: p1HomeView,
  },
  {
    path: "/",
    name: "p1HomeView",
    component: p1HomeView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
